import { render, staticRenderFns } from "./ReportePerfilCargo.vue?vue&type=template&id=2903d852&scoped=true"
import script from "./ReportePerfilCargo.vue?vue&type=script&lang=js"
export * from "./ReportePerfilCargo.vue?vue&type=script&lang=js"
import style0 from "./ReportePerfilCargo.vue?vue&type=style&index=0&id=2903d852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2903d852",
  null
  
)

export default component.exports